﻿
(function ($, document) {

    function SetLoading() {
        $('.js-product-page-pricing-lines').append('<div class="product-listing--loading"></div>');
    }

    function RemoveLoading() {
        $('.js-product-page-pricing-lines').find('.product-listing--loading').remove();
    }

    function UpdateProductPriceLines($productPriceLines, options, fallbackUrl, updateUrl) {
        SetLoading();
        var isExpanded = $('.js-broker-control').hasClass('active');
        $.ajax({
            url: '/api/products/page',
            data: JSON.stringify(options),
            method: 'POST',
            contentType: "application/json"
        }).done(function (result) {
            $productPriceLines.html(result.PriceLinesControl);
            RemoveLoading();
            $(document).foundation('equalizer', 'reflow');
            document.ReinitializeTippy();
            Crafted.Utilities.initBrokerTable();
            if (History.enabled && updateUrl) {
                $productPriceLines.data('url-pushed', true);
                History.pushState(null, document.title, result.PersistentUrl);
            }
            if (isExpanded) {
                $('.js-broker-control').trigger('click');
            }
        }).error(function (result) {
            if (updateUrl) {
                window.location.href = fallbackUrl;
            } else {
                window.location.reload(true);
            }
        });
    }

    $(document).on('click', '.js-product-page-pricing-toggle .toggle-switch__option', function (e) {
        e.preventDefault();
        // bool toggle will have already updated this
        var $item = $(this).parent('.toggle-switch__control').find('.toggle-switch__option.toggle-switch__option--active');
        var pricing = $item.data('option');
        var fallbackUrl = $item.attr('href');

        var $priceLines = $('.js-product-page-pricing-lines');

        var options = {
            ProductId: $priceLines.data('product'),
            CurrentPricingView: pricing,
            SalesAnalysisCode: GetQuerystringParameter('sac')
        };

        UpdateProductPriceLines(
            $priceLines,
            options,
            fallbackUrl,
            true
        );
    });

    function GetQuerystringParameter(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    History.Adapter.bind(window, 'statechange', function () {
        var $priceLines = $('.js-product-page-pricing-lines');
        if ($priceLines.length && !$priceLines.data('url-pushed')) {

            var options = {
                ProductId: $priceLines.data('product'),
                CurrentPricingView: GetQuerystringParameter('price'),
                SalesAnalysisCode: GetQuerystringParameter('sac')
            };

            fallbackUrl = window.location.href;

            UpdateProductPriceLines(
                $priceLines,
                options,
                fallbackUrl,
                false
            );
        }
        $priceLines.data('url-pushed', false);
    });

})(jQuery, document);